import React from 'react';
import { Grid, Segment, Dropdown, Form, Button, Checkbox } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';
import CustomDatePicker from '../_reusables/Datepicker';

const CreateMVForm = ({
  vmOptions,
  changeFrom,
  changeTo,
  selectAllVM,
  selectAll,
  downloadOrders,
  downloadOLI,
  downloadPayments,
  downloadMV,
  dateFrom,
  dateTo,
  changeVM,
  loading
}) => (
  <Grid centered style={{ marginTop: '8vh' }}>
    <Helmet>
      <title>Download Data</title>
    </Helmet>
    <Grid.Row centered>
      <Grid.Column width={4}>
        <h2
          style={{
            fontWeight: 400,
            border: '1px solid #555',
            textAlign: 'center',
            color: '#555',
            padding: '0.5em'
          }}
        >
          Download Data
        </h2>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={8}>
        <Segment raised>
          <h3 style={{ fontWeight: 400 }}>Vending Machine Downloads</h3>
          <Form>
            <Segment>
              <Form.Field required>
                <label>Date From : </label>
                <CustomDatePicker dateValue={dateFrom} onDateChange={changeFrom} />
              </Form.Field>
              <Form.Field required>
                <label>Date To: </label>
                <CustomDatePicker dateValue={dateTo} onDateChange={changeTo} />
              </Form.Field>
              <Form.Field required >
                <label>Select Vending Machine</label>
                <Form.Group>
                  <Dropdown
                    placeholder="Select Vending Machine"
                    style={{ width: '70%' }}
                    loading={loading}
                    disabled={selectAll}
                    selection
                    multiple
                    search
                    onChange={changeVM}
                    options={vmOptions}
                  />
                  <span style={{ margin: '0.5em 0.5em 0 0.5em' }} >-OR-</span>
                  <Checkbox
                    style={{ margin: '0.5em 0 0 0' }}
                    label="Select All"
                    onChange={selectAllVM}
                  />
                </Form.Group>
              </Form.Field>
              <Form.Field />
            </Segment>
            <Grid.Row>
              <Button
                disabled={loading}
                onClick={downloadOrders}
                basic
                color="blue"
                style={{ marginRight: '2.5em' }}
              >
                Orders
              </Button>
              <Button
                disabled={loading}
                onClick={downloadOLI}
                basic
                color="black"
                style={{ marginRight: '2.5em' }}
              >
                Order Line Items
              </Button>
            </Grid.Row>
            <Grid.Row>
              <br />
              <hr style={{ width: '50%' }} />
              <h3 style={{ fontWeight: '400', marginTop: '1em', marginBottom: '1.2em' }}>
                Extra Downloads
              </h3>
            </Grid.Row>
            <Grid.Row>
              <Button
                disabled={loading}
                onClick={downloadPayments}
                basic
                color="blue"
                style={{ marginRight: '2.5em' }}
              >
                Payments
              </Button>
              <Button disabled={loading} onClick={downloadMV} basic color="black">
                Manufacturer Variants
              </Button>
            </Grid.Row>
          </Form>
          <br /> <br />
        </Segment>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default CreateMVForm;



// WEBPACK FOOTER //
// ./src/Modules/DownloadCSV/component.jsx